import React, { useCallback, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { NativeHeroSection } from './NativeHeroSection';

/**
 * Marketing hero: native React (replaces legacy standalone HTML iframe).
 *
 * Scroll:
 *   - `/funciones` → `#funciones` (funcionalidades)
 *   - `/negocios` → `#negocios` (`#industrias`)
 *   - `/#hero-dia` → handled by `ScrollToHash` + `id="hero-dia"` on `.inside` (no double scroll).
 */

export const LANDING_HERO_DIA_HASH = 'hero-dia';

export const HeroSection: React.FC = () => {
  const { pathname } = useLocation();
  const hasScrolled = useRef(false);

  const scrollToId = useCallback((id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  const runMarketingScroll = useCallback(() => {
    if (pathname === '/funciones') {
      window.requestAnimationFrame(() => {
        scrollToId('funciones');
      });
      if (!hasScrolled.current) {
        hasScrolled.current = true;
        window.setTimeout(() => scrollToId('funciones'), 120);
      }
    }

    if (pathname === '/negocios') {
      window.setTimeout(() => {
        scrollToId('negocios');
      }, 120);
    }
  }, [pathname, scrollToId]);

  useEffect(() => {
    hasScrolled.current = false;
    runMarketingScroll();
  }, [runMarketingScroll]);

  return (
    <section className="w-full" aria-label="Inicio">
      <NativeHeroSection />
    </section>
  );
};
